/**
 * @generated SignedSource<<48a946e8dc425f65203c5acd8829d9df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
import { FragmentRefs } from "relay-runtime";
export type HomePanelGroupsMenu_object$data = {
  readonly __typename: string;
  readonly homePanelGroup: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly id: string;
  readonly type?: NoteStreamType;
  readonly " $fragmentType": "HomePanelGroupsMenu_object";
};
export type HomePanelGroupsMenu_object$key = {
  readonly " $data"?: HomePanelGroupsMenu_object$data;
  readonly " $fragmentSpreads": FragmentRefs<"HomePanelGroupsMenu_object">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomePanelGroupsMenu_object",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "type": "NoteStream",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HomePanelGroup",
      "kind": "LinkedField",
      "name": "homePanelGroup",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HomePanelObjectInterface",
  "abstractKey": "__isHomePanelObjectInterface"
};
})();

(node as any).hash = "dfdd747e22a62f407aac992cc1bc946c";

export default node;
